import React, {memo} from 'react';
import {AdminListPage} from '../../Component/Page/AdminListPage';
import {removeUserMutation} from '../../GraphQL/Mutation/removeUserMutation';
import {getUserListQuery} from '../../GraphQL/Query/getUserListQuery';

export const UserAdminListScreen: React.FC = memo(() => (
  <AdminListPage entityType="user" getQuery={getUserListQuery} deleteMutation={removeUserMutation}/>
));
